import React, {createRef, useState} from "react";
import Uppy from '@uppy/core'
import XHRUpload from '@uppy/xhr-upload'
import { DragDrop } from '@uppy/react'
import ReCAPTCHA from "react-google-recaptcha";

import CloseIcon from "../icons/CloseIcon";


export default ({index, uploadEndpoint, sendContact, status}) => {

    const [file, setFileId] = useState(0);
    const [thumbnail, setThumbnail] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const recaptchaRef = createRef();

    const captchaMeta = document.querySelector('meta[name="captcha_key"]');
    const captchaKey = captchaMeta ? captchaMeta.getAttribute('content') : null;

    const uppy = new Uppy({
        restrictions: { maxNumberOfFiles: 1 },
        autoProceed: true,
    });
    uppy.use(XHRUpload, { endpoint: uploadEndpoint })
    uppy.on('complete', (result) => {
        setFileId(result.successful[0].response.body.id);
        setThumbnail(result.successful[0].response.body.thumbnail);
        setFileName(result.successful[0].response.body.name);
    });

    return <div className="problem-solver__contact">
        <div className="problem-solver__contact__inner">
            <h4 className="problem-solver__contact__number">{index}.</h4>
            <h2 className="problem-solver__contact__title">
                Feel free to send us a picture of your insect or bug. Our entomologist will identify
                it and get back to you as soon as possible!
            </h2>

            <div className="problem-solver__contact__form">
                <form onSubmit={async (e) => {
                    e.preventDefault();
                    const token = captchaKey ? await recaptchaRef.current.executeAsync() : null;
                    sendContact(name, email, message, file, token);
                    return false;
                }}>

                    <div className="field">
                        <label className="left">Name*</label>
                        <div className="middleColumn">
                            <input type="text" name="Name" value={name} required={true} onChange={(e) => {
                                setName(e.target.value);
                            }} />
                        </div>
                    </div>

                    <div className="field">
                        <label className="left">Email*</label>
                        <div className="middleColumn">
                            <input type="email" name="Email" value={email} required={true} onChange={(e) => {
                                setEmail(e.target.value);
                            }} />
                        </div>
                    </div>

                    <div className="field">
                        <label className="left">Anything you want to say about the bug</label>
                        <div className="middleColumn">
                            <textarea
                                name="Message" value={message} required={true}
                                onChange={(e) => {
                                    setMessage(e.target.value);
                                }}
                                ></textarea>
                        </div>
                    </div>

                    <div className="field">
                        <label className="left">Upload a photo (max 1mb)</label>
                        <div className="middleColumn">
                            <DragDrop
                                uppy={uppy}
                                locale={{
                                    strings: {
                                        dropHereOr: 'Drag and drop to upload your photo. %{browse}',
                                        browse: 'browse',
                                    },
                                }}
                            />

                            {!!thumbnail && <div className="problem-solver__preview">
                                <div className="problem-solver__preview-image">
                                    <div>
                                        <img src={thumbnail} />
                                        <span>{fileName}</span>
                                    </div>
                                    <a href={'#'} onClick={(e) => {
                                        e.preventDefault();
                                        setFileId(0);
                                        setThumbnail(null);
                                        setFileName(null);
                                        return false;
                                    }}>
                                        <CloseIcon />
                                    </a>
                                </div>
                            </div>}
                        </div>
                    </div>


                    {!!captchaKey && <div className="field">
                        <div className="middleColumn">
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size="invisible"
                                sitekey={captchaKey}
                            />
                        </div>
                    </div>}

                    <div className="btn-holder">
                        <button type={'submit'} className="btn btn--blue btn--blue--solid">Submit</button>
                    </div>

                    {status === 'IN_PROGRESS' && <p className="problem-solver__status">Please wait</p>}
                    {status === 'COMPLETED' && <p className="problem-solver__status">Your message is sent</p>}

                </form>
            </div>

        </div>
    </div>;


}
